import Link from "next/link";

const FooterLight = () => {
  return (
    <footer className="bg-gray-50 py-8 text-center text-xs text-base-content/30">
      <div className="max-w-7xl mx-auto px-4">
        <p>
          2019 - {new Date().getFullYear()}. All rights reserved. PFPMaker.com is owned and operated by Logopony OÜ, 6 Sepapaja, 15551 Tallinn, Estonia, Company no: 14309787, VAT no: EE101995894
        </p>
        <div className="mt-2">
          <Link href="https://pfpmaker.com/privacy-policy" className="hover:underline">
            Privacy Policy
          </Link>
          {" / "}
          <Link href="https://pfpmaker.com/terms-of-service" className="hover:underline">
            Terms of Service
          </Link>
        </div>
        <div className="mt-2">
          <a href="mailto:support@pfpmaker.com" className="hover:underline">
            support@pfpmaker.com
          </a>
        </div>
      </div>
    </footer>
  );
};

export default FooterLight;
